import { Col, Row } from "react-bootstrap";
import styles from "./app-tabs.module.scss";

export interface TabComponentInterface {
  buttonName: string;
  id: number;
}

interface IProps {
  buttons: TabComponentInterface[];
  onChange: (id: number) => void;
  selectedTabId?: number | null;
}

const AppTabs = (props: IProps) => {
  const { buttons, onChange, selectedTabId } = props;

  return (
    <div className={styles.tabButtonGroup}>
      <Row className="w-100 m-0 h-100">
        {buttons.map((button) => {
          return (
            <Col
              key={button.id}
              className={`${styles.tabButton} ${
                selectedTabId === button.id ? styles.selected : ""
              } font-size-12`}
              onClick={() => {
                onChange(button.id);
              }}
            >
              {button.buttonName}
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default AppTabs;
